import { Step } from 'react-joyride';

export const documentsTourSteps: Step[] = [
  {
    target: '[data-tour="documents-header"]',
    content: (
      <div>
        <h4>Document Management</h4>
        <p>
          Handle all document-related tasks including e-signatures, form creation, and identity
          verification in one place.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="esignature-section"]',
    content: (
      <div>
        <h4>E-Signature</h4>
        <p>
          Upload documents for customers to sign electronically. Track signature status and manage
          signed documents securely.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="forms-section"]',
    content: (
      <div>
        <h4>Forms & Templates</h4>
        <p>
          Create reusable form templates for collecting customer information. Build custom forms
          with drag-and-drop fields.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="verification-section"]',
    content: (
      <div>
        <h4>Document Verification</h4>
        <p>
          Verify customer identity documents like IDs, passports, and licenses. Streamline your KYC
          process.
        </p>
      </div>
    ),
    placement: 'right'
  }
];
